export const getInputFields = findDoc => {
  return [...findDoc].map(el => {
    return {
      id: el.getAttribute('id'),
      fieldname: el?.getAttribute('name') ? el.getAttribute('name') : '',
      placeholder: el?.getAttribute('placeholder') ? el.getAttribute('placeholder') : '',
      type: el.getAttribute('type') ? el.getAttribute('type') : 'text',
      value: el.getAttribute('value') ? el.getAttribute('value') : '',
      min: el.getAttribute('min') ? el.getAttribute('min') : '',
      max: el.getAttribute('max') ? el.getAttribute('max') : '',
      required: el.getAttribute('required') === 'true',
      isChecked: el.getAttribute('checked') === 'true',
      isrecipient: el.getAttribute('data-type')
    };
  });
};

export const getDropdownFields = (findSelectDropDown, selectDetails) => {
  [...findSelectDropDown].forEach(el => {
    const optionsList = el.querySelectorAll('option');

    const options = [];
    if (optionsList?.length) {
      [...optionsList].forEach(item => {
        options.push({ value: item.innerHTML });
      });
    }

    selectDetails.push({
      fieldname: el.getAttribute('name'),
      options,
      id: el.getAttribute('id')
    });
  });
};
